import { appRouterPaths } from "@/services/navigation";
import { ContactsPageV2 } from "@/pages/ContactsPageV2";
import type { RouteProps } from "react-router-dom";

export const contactsPageV2Route: RouteProps = {
  path: appRouterPaths.contacts.base,
  element: <ContactsPageV2 />,
};
